import {
  ATUALIZAR_DADOS_PESSOAIS_REQUERIMENTO,
  OBTER_LABEL_FORMULARIOS_SUCCESS,
  OBTER_PERITOS_SUCCESS,
  OBTER_REQUERIMENTOS_SUCCESS,
  OBTER_TODOS_FORMULARIOS_REQUEST,
  OBTER_TODOS_FORMULARIOS_SUCCESS,
  RESET_REQUERIMENTOS,
} from './constants';

const initialState = {
  peritos: [],
  deferido: [],
  indeferido: [],
  'em andamento': [],
  'Pendente Correção': [],
  allForms: [],
  allFormsRequestDone: false,
  allFormsByStatusDone: {},
  allFormsLabels: [],
  allFormsLabelsRequestDone: false,

  dadosPessoaisRequerimento: {
    email: '',
    celular: '',
    telefoneFixo: '',

    nome: '',
    dtNascimento: '',
    nacionalidade: '',
    sexo: '',
    estadoCivil: '',
    pai: '',
    mae: '',

    rg: '',
    orgEmissor: '',
    uf: '',
    cpf: '',
    dtEmissao: '',

    endereco: '',
    numero: '',
    complemento: '',
    cep: '',
    bairro: '',
    cidade: '',
    estado: '',

    banco: '',
    agencia: '',
    conta: '',
    digito: '',
  },
};

// eslint-disable-next-line default-param-last
export default function requerimento(state = initialState, action) {
  switch (action.type) {
    case OBTER_PERITOS_SUCCESS:
      return {
        ...state,
        peritos: action.peritos,
      };

    case OBTER_REQUERIMENTOS_SUCCESS:
      return {
        ...state,
        [action.status]: action.data,
        allFormsByStatusDone: { [action.status]: true },
      };

    case OBTER_TODOS_FORMULARIOS_SUCCESS:
      return {
        ...state,
        allForms: action.payload,
        allFormsRequestDone: true,
      };

    case OBTER_TODOS_FORMULARIOS_REQUEST:
      return {
        ...state,
        allFormsRequestDone: false,
      };

    case OBTER_LABEL_FORMULARIOS_SUCCESS:
      return {
        ...state,
        allFormsLabels: action.payload,
        allFormsLabelsRequestDone: true,
      };

    case ATUALIZAR_DADOS_PESSOAIS_REQUERIMENTO:
      return {
        ...state,
        dadosPessoaisRequerimento: {
          ...state.dadosPessoaisRequerimento,
          ...action.payload,
        },
      };

    case RESET_REQUERIMENTOS:
      return initialState;

    default:
      return state;
  }
}
